export default "__VITE_ASSET__DA96sHMD__"